const baseConfig = {
    // put any unchanging configuration information in here
};

const deployConfig = {
    apiUrl: "https://policydesignlab-dev.ncsa.illinois.edu/pdl",
    ga_tracking_id: "G-GFR8PTXMDM",
    ...baseConfig
};

const developConfig = {
    apiUrl: "https://policydesignlab-dev.ncsa.illinois.edu/pdl",
    ga_tracking_id: "G-K4MLHWSVVT",
    ...baseConfig
};

const localConfig = {
    apiUrl: "http://localhost:5000/pdl",
    ga_tracking_id: "none",
    ...baseConfig
};

function getConfig() {
    if (process.env.APP_ENV === "local") {
        return localConfig;
    }
    if (process.env.APP_ENV === "development") {
        return developConfig;
    }
    return deployConfig;
}

export const config = getConfig();
